'use client';

import { c as _c } from "react/compiler-runtime";
import { motion, useScroll } from 'motion/react';
export function ProgressBar() {
  const $ = _c(2);
  const {
    scrollYProgress
  } = useScroll();
  let t0;
  if ($[0] !== scrollYProgress) {
    t0 = <motion.div className="fixed inset-x-0 top-0 z-50 h-1 origin-left bg-foreground" style={{
      scaleX: scrollYProgress
    }} />;
    $[0] = scrollYProgress;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}